<template>
     <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-12 mb-20">
    <!-- Título -->
    <h2 class="text-3xl font-bold text-gray-800 mb-8 text-center">Uniforme</h2>
    
    <!-- Grid de Productos -->
    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
     
      <div v-for="product in products" :key="product.name" class="bg-white rounded-lg shadow-md overflow-hidden  duration-500 hover:scale-105 hover:shadow-xl">
        <router-link :to="product.uri">
          <img 
          :src="product.image" 
          alt="Nomad Pouch" 
          class="w-full object-cover flex-1"
        />
        <div class="mt-4 p-4">
          <h3 class="text-lg font-semibold text-gray-700">{{product.name}}</h3>
          <p class="text-gray-500 italic">{{product.description}}</p>
          <p class="text-gray-800 font-bold mt-2">S/. {{product.price.toFixed(2)}}</p>
        </div>
      </router-link>
        
      </div>
     
    </div>
  </div>
</template>
<script>

import image2 from '@/assets/uniform/2.jpg';
import image3 from '@/assets/uniform/3.jpg';
import image6 from '@/assets/uniform/6.jpg';
export default {
    name: 'ProductsComponent',
    data() {
    return {
      products: [
        { name: '2024 T1 Worlds Uniform Jersey',uri:'/product/2024-t1-worlds-uniform-jersey', description: 'Camiseta mundial 2024', price: 89.00, price_original: 120.00, image: image3},
        { name: '2024 T1 Worlds Uniform Jacket',uri: '/product/2024-t1-worlds-uniform-jacket', description: 'Casaca mundial 2024', price: 159.00, image: image6 },
        { name: 'Pack Uniform Jacket and Jersey',uri: '/product/pack-uniform-jacket-jersey', description: 'Pack Casaca y Camiseta', price: 220.00, image: image2 },
     
      ],
    
    };
  },

}
</script>